<template>
  <Layout>
    <div v-if="false" class="col-sm-12">
      <div class="alert alert-warning text-dark" role="alert"><h4><i class="mdi mdi-alert-circle mr-2"></i> Aviso –
        Atualizações da Nota Fiscal de Serviços Eletrônica (NFS-e)</h4>
        <h5>Reforma Tributária do Consumo</h5>
        <p>
          Informamos que, em <strong>1º de janeiro</strong>, entrou em vigor a nova versão da
          <strong>Nota Fiscal de Serviços Eletrônica (NFS-e)</strong>, adequada ao
          <strong>padrão nacional da Reforma Tributária do Consumo</strong>, contemplando as
          atualizações relacionadas ao <strong>Imposto sobre Bens e Serviços (IBS)</strong> e à
          <strong>Contribuição sobre Bens e Serviços (CBS)</strong>.
        </p>

        <p>
          O município continuará utilizando o <strong>emissor próprio no modelo ABRASF 2.04</strong>,
          devidamente ampliado e compatibilizado com as exigências do
          <strong>modelo nacional de dados da NFS-e</strong>, assegurando o correto compartilhamento
          das informações fiscais com o <strong>Ambiente de Dados Nacional (ADN)</strong>.
          Também será disponibilizada a <strong>exportação do XML no layout nacional</strong>,
          permitindo que os sistemas e aplicativos externos tenham
          <strong>tempo hábil para adaptação</strong> às novas estruturas.
        </p>

        <p>
          <strong>Importante:</strong> conforme disposto na <strong>Nota Técnica nº 004</strong>,
          publicada em <strong>10 de dezembro de 2025</strong> pelo
          <strong>Comitê Gestor da Reforma Tributária do Consumo</strong>, os campos e informações
          pertencentes ao <strong>grupo IBS/CBS</strong>
          <strong> não serão obrigatórios neste primeiro momento</strong>.
          Assim, a ausência dessas informações <strong>não impedirá a emissão da NFS-e</strong>,
          sem prejuízo de que venham a ser exigidas em fases posteriores, de acordo com o cronograma
          a ser divulgado pelos órgãos competentes.
        </p>

        <p>
          As implementações realizadas poderão sofrer <strong>ajustes adicionais</strong>, em razão
          de eventuais alterações promovidas pelo
          <strong>Ambiente de Dados Nacional da Reforma Tributária do Consumo (RTC)</strong>.
          Ressaltamos, contudo, que <strong>não são esperadas alterações estruturais</strong> nos
          layouts publicados. Conforme esclarecido pelo Ambiente Nacional, a
          <strong>Nota Técnica nº 005</strong> será incorporada ao modelo da
          <strong>NT nº 004</strong>, de modo que futuras atualizações deverão ser
          <strong>pontuais</strong>, restritas a <strong>regras de validação e consistência</strong>.
          Informamos ainda que as adaptações previstas na
          <strong>Nota Técnica nº 005</strong>, publicada em <strong>19 de novembro de 2025</strong>,
          serão implementadas <strong>ao longo do exercício de 2026</strong>, conforme prazos que
          serão divulgados no <strong>Portal da NFS-e</strong>.
        </p>

        <p>
          Reforçamos a importância de que <strong>contribuintes e desenvolvedores</strong> acompanhem
          atentamente as atualizações normativas e revisem seus processos e integrações, garantindo
          a <strong>aderência gradual ao novo padrão nacional</strong>.
        </p>

        <p>
          As mudanças implementadas nesta <strong>primeira fase da Reforma Tributária</strong>,
          conforme as Notas Técnicas publicadas, consistem na <strong>criação e exigência</strong> das
          seguintes informações:
        </p>

        <ul>
          <li><strong>NBS (Classificação Brasileira de Serviços)</strong>;</li>
          <li><strong>Operação Tributária</strong>;</li>
          <li><strong>Classificação Tributária</strong>.</li>
        </ul>

        <p>
          Essas classificações, alinhadas aos serviços previstos na
          <strong>Lei Complementar nº 116</strong>, contarão com
          <strong>filtros específicos por tipo de serviço</strong>, facilitando o correto
          enquadramento no momento da emissão da NFS-e.
        </p>

        <p>
          Em caso de dúvidas — especialmente na eventual
          <strong>ausência de alguma classificação necessária</strong> de NBS, Classificação
          Tributária ou Operação Tributária, a <strong>equipe de suporte permanece à disposição</strong>
          pelo e-mail: <strong>suporte@dattasystem.com.br</strong>
        </p>
      </div>
    </div>
    <div v-if="empresa && empresa.eco_codigo" class="row">
      <div v-show="empresa.tab_107situacao !== '1003'" class="col-md-8 col-sm-12">
        <div class="alert alert-danger text-dark" role="alert"><h4><i class="mdi mdi-block-helper mr-2"></i> Empresa
          bloqueada para emissão de Nota Fiscal Eletrônica</h4>
          <p>A empresa possui pendências cadastrais ou fiscais. <br/>
            Procurar o setor tributário ou de finanças do município.</p>
          <p>
            {{ entidade.ent_nome }}<br>
            Endereço: {{ entidade.ent_endereco }}, {{ entidade.ent_numero }}, {{ entidade.ent_bairro }},
            {{ entidade.mun_nome }} - {{ entidade.mun_uf }}<br>
            Telefone: {{ entidade.ent_telefone1 }}<br>
            E-mail: {{ entidade.ent_mail }}<br>
            Site: {{ entidade.ent_site }}<br>
          </p>
        </div>
      </div>
    </div>
    <div v-if="user.is_admin" class="row">
      <div v-show="pedidos_cancelamentos > 0" class="col-sm-12">
        <Transition name="slide-down">
          <div class="alert-cancelamento">
            <div class="alert-icon">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <circle cx="10" cy="10" r="9" stroke="#b45309" stroke-width="1.5"/>
                <path d="M10 6v5" stroke="#b45309" stroke-width="1.5" stroke-linecap="round"/>
                <circle cx="10" cy="14" r="0.8" fill="#b45309"/>
              </svg>
            </div>
            <div class="alert-body">
              <p class="alert-title">Atenção — pedidos de cancelamento pendentes</p>
              <p class="alert-desc">
                Há <strong>{{ pedidos_cancelamentos }} {{ pedidos_cancelamentos === 1 ? 'pedido' : 'pedidos' }}</strong>
                de cancelamento aguardando análise e aprovação.
              </p>
            </div>
            <div class="alert-actions">
              <button class="btn-cancelamento" @click="pagePedidos()">
                Ver pedidos
                <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                  <path d="M2.5 6.5h8M7 3l3.5 3.5L7 10" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"
                        stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
          </div>
        </Transition>
      </div>
    </div>
    <NotaFiscalDashboard/>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/dados/app.config.json";
import NotaFiscalDashboard from "@/router/views/dashboards/components/NotaFiscalDashboard.vue";

const {listNotasPedidosCancelamento} = require("../../../api/nfse/nota");
export default {
  page: {
    title: "Painel",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    NotaFiscalDashboard,
    Layout
  },
  data() {
    return {
      title: "Painel",
      items: [
        {
          text: "Painel",
          active: true,
        }
      ],
      httpFichaCadastro: false,
      user: null,
      empresa: null,
      filtros_pedidos_cancelamento: {
        pagina: 1,
        status: '1',
      },
      pedidos_cancelamentos: [],
      duams: [],
      contadores: {
        total_contribuinte: 0,
        total_movimento: 0.00,
        total_nota: 0,
      }
    };
  },
  created() {
    this.user = this.$store.state.auth.currentUser;
    if (this.user && this.user.is_admin) {
      this.listPedidosCancelamentos()
    }
    this.empresa = this.$store.state.auth.currenEmpresa;
  },
  computed: {
    entidade: {
      get: function () {
        return this.$store.state.auth.currentEntidade;
      },
    },
    valor_total_duams: {
      get: function () {
        return this.duams
            .map(d => Number(d.dut_valortributo))
            .reduce((sum, current) => sum + current, 0);
      }
    },
    valor_total_atualizado_duams: {
      get: function () {
        return this.duams
            .map(d => Number(d.dut_valortotal))
            .reduce((sum, current) => sum + current, 0);
      }
    }
  },
  methods: {
    listPedidosCancelamentos() {
      this.httpSend = true;
      listNotasPedidosCancelamento(0, this.filtros_pedidos_cancelamento).then(result => {
        if (result.status) {
          this.pedidos_cancelamentos = result.dados.total;
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    pagePedidos() {
      this.$router.push({name: 'admin-gestao-pedidos-cancelamento'});
    },
  },
};
</script>
<style scoped>

/* ─── Alerta cancelamentos ───────────────────────────────── */
.alert-cancelamento {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  background: #fffbeb;
  border: 1px solid #fcd34d;
  border-left: 4px solid #f59e0b;
  border-radius: 10px;
  padding: 1rem 1.25rem;
}

.alert-icon {
  flex-shrink: 0;
  margin-top: 1px;
}

.alert-body {
  flex: 1;
  min-width: 0;
}

.alert-title {
  margin: 0 0 3px;
  font-size: 13px;
  font-weight: 600;
  color: #92400e;
}

.alert-desc {
  margin: 0;
  font-size: 13px;
  color: #b45309;
  line-height: 1.5;
}

.alert-desc strong {
  font-weight: 600;
  color: #92400e;
}

.alert-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.btn-cancelamento {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #f59e0b;
  color: #fff;
  border: none;
  border-radius: 7px;
  padding: 7px 14px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  font-family: 'DM Sans', sans-serif;
  transition: background 0.15s, transform 0.1s;
}

.btn-cancelamento:hover {
  background: #d97706;
}

.btn-cancelamento:active {
  transform: scale(0.97);
}

.btn-fechar-alert {
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 5px;
  border-radius: 6px;
  transition: background 0.15s;
}

.btn-fechar-alert:hover {
  background: #fde68a;
}
</style>

